<div class="header-controls">
    <span [class.link]="!(isOpen$ | async)"
     (click)="enterDetailsClicked()">
        Enter order details
    </span>
    <span class="ml-1"  *ngIf="isOpen$ | async as open" [class.link]="open" 
     (click)="cancelClicked()">
        Cancel
    </span>
</div>
<div class="form-container" *ngIf="isOpen$ | async" >
    <app-order-form #orderForm>
    </app-order-form>
</div>
